import axios from 'axios';
import React, { useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import * as APIS from '../../Config/Apis';
import { getToken } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';
import { useFormik } from 'formik';
import AlertError from "../Layouts/AlertError";
import { DatePicker } from 'antd';
import moment from 'moment';

import { SearchOutlined } from '@ant-design/icons';
import { red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey } from '@ant-design/colors';

import { Layout, Breadcrumb, PageHeader, Collapse, Row, Col, Button, Select, Table, Input, Space, Tag } from "antd";
import AlertDismissError from '../Layouts/AlertDismissError';
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Option } = Select;

function AgentCardFloats() {
    const token = getToken();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const formik = useFormik({
        initialValues: {
            start_date: moment("00:00:00", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment("23:59:59", "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        },
        validationSchema: Yup.object({
            start_date: Yup.string().required(),
            end_date: Yup.string().required(),
        }),
        onSubmit: values => {
            console.log(values);
            setError(null);
            setLoading(true);
            setTableError(null);
            let params = {
                start_date: values.start_date,
                end_date: values.end_date,
            };
            let queryStringFilter = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            console.log(queryStringFilter);
            setLoading(false);

            setFiltersQuery(queryStringFilter);
            // clearFilters();
            setTableDraw(1);
            params = { draw: 1, start: 0, length: 10 };
            let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            queryString += "&" + queryStringFilter + columnsQuery;
            getTableData(queryString);
        },
    });

    useComponentDidMount(() => {
        const params = { draw: 1, start: 0, length: 10 };
        const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        getTableData(queryString);
    });

    const [filtersQuery, setFiltersQuery] = useState('');
    const [columnsQuery, setColumnsQuery] = useState('');
    const [tableDraw, setTableDraw] = useState(1);
    const [tableData, setTableData] = useState(false);
    const [tableError, setTableError] = useState(null);
    const [tableTotalCount, setTableTotalCount] = useState(0);
    const [tableFilterCount, setTableFilterCount] = useState(0);
    const [tableFilterValues, setTableFilterValues] = useState(null);
    const clearFilters = () => {
        setTableFilterValues(null);
    };
    const searchColumnText = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    // onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    onPressEnter={() => { confirm() }}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnDate = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                {
                    selectedKeys[0] ? <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        defaultValue={moment(selectedKeys[0], "YYYY-MM-DD")}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    /> : <DatePicker
                        style={{ marginBottom: 8, display: 'block' }}
                        onChange={(moment) => {
                            try {
                                setSelectedKeys([moment.format("YYYY-MM-DD")]);
                            } catch (e) {
                                setSelectedKeys([]);
                            }
                        }}
                    />
                }
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectTypes = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">All</Option>
                    <Option value="0">None</Option>
                    <Option value="2">Add</Option>
                    <Option value="1">Remove</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const searchColumnSelectStatus = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select defaultValue={selectedKeys[0]} style={{ marginBottom: 8, display: 'block' }} onChange={value => setSelectedKeys(value ? [value] : [])}>
                    <Option value="-1">All</Option>
                    <Option value="1">Pending</Option>
                    <Option value="2">Approved</Option>
                    <Option value="0">Denied</Option>
                </Select>
                <Space>
                    <Button
                        type="primary"
                        onClick={() => { confirm() }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? red.primary : undefined }} />,
    });
    const tableColumns = [
        "agent_float_id", // 0
        "agent_name", // 1
        "old_balance", // 2
        "amount", // 3
        "new_balance", // 4
        "type", // 5
        "action", // 6
        "card_number", // 7
        "card_old_balance", // 8
        "card_new_balance", // 9
        "customer_name", // 10
        "customer_phone_number", // 11
        "company_name", // 12
        "requested_at", // 13
        "approval_updated_at", // 14
        "status", // 15
        "reason", // 16
    ]
    const tableColumnsHead = [
        { dataIndex: tableColumns[0], filteredValue: tableFilterValues && tableFilterValues[tableColumns[0]] ? tableFilterValues[tableColumns[0]] : null, ...searchColumnText(tableColumns[0]), title: "Id" },
        { dataIndex: tableColumns[1], filteredValue: tableFilterValues && tableFilterValues[tableColumns[1]] ? tableFilterValues[tableColumns[1]] : null, ...searchColumnText(tableColumns[1]), title: "Agent" },
        { dataIndex: tableColumns[2], filteredValue: tableFilterValues && tableFilterValues[tableColumns[2]] ? tableFilterValues[tableColumns[2]] : null, ...searchColumnText(tableColumns[2]), title: "Old Balance" },
        { dataIndex: tableColumns[3], filteredValue: tableFilterValues && tableFilterValues[tableColumns[3]] ? tableFilterValues[tableColumns[3]] : null, ...searchColumnText(tableColumns[3]), title: "Amount" },
        { dataIndex: tableColumns[4], filteredValue: tableFilterValues && tableFilterValues[tableColumns[4]] ? tableFilterValues[tableColumns[4]] : null, ...searchColumnText(tableColumns[4]), title: "New Balance" },
        {
            dataIndex: tableColumns[5], filteredValue: tableFilterValues && tableFilterValues[tableColumns[5]] ? tableFilterValues[tableColumns[5]] : null, ...searchColumnSelectTypes(tableColumns[5]), title: "Type",
            render: value => {
                let color = grey.primary;
                if (value === 'None') {
                    color = grey.primary;
                }
                if (value === 'Add') {
                    color = green.primary;
                }
                if (value === 'Remove') {
                    color = red.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value}
                    </Tag>
                );
            }
        },
        { dataIndex: tableColumns[6], filteredValue: tableFilterValues && tableFilterValues[tableColumns[6]] ? tableFilterValues[tableColumns[6]] : null, ...searchColumnText(tableColumns[6]), title: "Event" },
        { dataIndex: tableColumns[7], filteredValue: tableFilterValues && tableFilterValues[tableColumns[7]] ? tableFilterValues[tableColumns[7]] : null, ...searchColumnText(tableColumns[7]), title: "Card Number" },
        { dataIndex: tableColumns[8], filteredValue: tableFilterValues && tableFilterValues[tableColumns[8]] ? tableFilterValues[tableColumns[8]] : null, ...searchColumnText(tableColumns[8]), title: "Card Old Balance" },
        { dataIndex: tableColumns[9], filteredValue: tableFilterValues && tableFilterValues[tableColumns[9]] ? tableFilterValues[tableColumns[9]] : null, ...searchColumnText(tableColumns[9]), title: "Card New Balance" },
        { dataIndex: tableColumns[10], filteredValue: tableFilterValues && tableFilterValues[tableColumns[10]] ? tableFilterValues[tableColumns[10]] : null, ...searchColumnText(tableColumns[10]), title: "Customer Name" },
        { dataIndex: tableColumns[11], filteredValue: tableFilterValues && tableFilterValues[tableColumns[11]] ? tableFilterValues[tableColumns[11]] : null, ...searchColumnText(tableColumns[11]), title: "Customer Phone" },
        { dataIndex: tableColumns[12], filteredValue: tableFilterValues && tableFilterValues[tableColumns[12]] ? tableFilterValues[tableColumns[12]] : null, ...searchColumnText(tableColumns[12]), title: "Company" },
        { dataIndex: tableColumns[13], filteredValue: tableFilterValues && tableFilterValues[tableColumns[13]] ? tableFilterValues[tableColumns[13]] : null, ...searchColumnDate(tableColumns[13]), title: "Requested At" },
        { dataIndex: tableColumns[14], filteredValue: tableFilterValues && tableFilterValues[tableColumns[14]] ? tableFilterValues[tableColumns[14]] : null, ...searchColumnDate(tableColumns[14]), title: "Updated At" },
        {
            dataIndex: tableColumns[15], filteredValue: tableFilterValues && tableFilterValues[tableColumns[15]] ? tableFilterValues[tableColumns[15]] : null, ...searchColumnSelectStatus(tableColumns[15]), title: "Status",
            render: value => {
                let color = grey.primary;
                if (value === 'Pending') {
                    color = red.primary;
                }
                if (value === 'Approved') {
                    color = green.primary;
                }
                if (value === 'Denied') {
                    color = grey.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value}
                    </Tag>
                );
            }
        },
        { dataIndex: tableColumns[16], filteredValue: tableFilterValues && tableFilterValues[tableColumns[16]] ? tableFilterValues[tableColumns[16]] : null, ...searchColumnText(tableColumns[16]), title: "Reason" },
    ];

    const tableHandleChange = (pagination, filters, sorter) => {
        console.log(filters);
        setTableFilterValues(filters);
        let columnsQuery = "";
        let index = 0
        tableColumns.forEach(column => {
            if (filters[column]) {
                let column_data = 'columns[' + index + '][data]=' + column;
                let column_name = 'columns[' + index + '][name]=';
                let column_orderable = 'columns[' + index + '][orderable]=false';
                let column_searchable = 'columns[' + index + '][searchable]=true';
                let column_search_value = 'columns[' + index + '][search][value]=' + filters[column][0];
                let column_search_regex = 'columns[' + index + '][search][regex]=false';
                columnsQuery += "&" + column_data;
                columnsQuery += "&" + column_name;
                columnsQuery += "&" + column_orderable;
                columnsQuery += "&" + column_searchable;
                columnsQuery += "&" + column_search_value;
                columnsQuery += "&" + column_search_regex;
            }
            index++;
        });
        setColumnsQuery(columnsQuery);
        const offset = pagination.current * pagination.pageSize - pagination.pageSize;
        const limit = pagination.pageSize;
        setTableDraw(tableDraw + 1);
        const params = { draw: tableDraw, start: offset, length: limit };
        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        queryString += "&" + filtersQuery + columnsQuery;
        getTableData(queryString);
    };

    const getTableData = (queryString) => {
        console.log(queryString);
        setLoading(true);
        setTableError(null);
        const suffix = queryString === null ? "" : "?" + queryString;
        const config = {
            "url": APIS.FULL_AGENT_CARD_FLOATS + suffix,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                console.log(JSON.stringify(response.data.data.datatable.recordsTotal));
                console.log(JSON.stringify(response.data.data.datatable.recordsFiltered));
                setLoading(false);
                setTableTotalCount(response.data.data.datatable.recordsTotal);
                setTableFilterCount(response.data.data.datatable.recordsFiltered);
                setTableData(response.data.data.datatable.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    let exportCsv = () => {
        let query = "";
        if (filtersQuery != "") {
            query += filtersQuery;
        }
        if (columnsQuery != "") {
            if (query == "") {
                query += columnsQuery.substring(1);
            } else {
                query += columnsQuery;
            }
        }
        const suffix = query === null ? "" : "?" + query;
        var config = {
            method: 'get',
            url: APIS.EXPORT_FULL_AGENT_CARD_FLOATS + suffix,
            headers: Object.assign(APIS.HEADERS),
        };
        // console.log(config);
        setLoading(true);
        setTableError(null);
        axios(config)
            .then(function (response) {
                // console.log(JSON.stringify(response.data));
                let filename = response.data.data.filename;
                let filepath = response.data.data.filepath;
                let fileUrl = APIS.APP_DOWNLOAD_FILE + "?filename=" + filename + "&filepath=" + filepath
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                $.ajax({
                    url: fileUrl,
                    type: 'get',
                    dataType: 'binary',
                    headers: Object.assign(APIS.HEADERS),
                    processData: false,
                    success: function (blob) {
                        var windowUrl = window.URL || window.webkitURL;
                        var url = windowUrl.createObjectURL(blob);
                        var anchor = document.createElement('a');
                        anchor.prop('href', url);
                        anchor.prop('download', filename);
                        anchor.get(0).click();
                        windowUrl.revokeObjectURL(url);
                    }
                });
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    }

    const exportButton = () => (
        <Button type="primary" loading={loading} onClick={exportCsv.bind(this)}>Export</Button>
    );

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: "0 15px" }}>
                <Breadcrumb style={{ margin: "5px 0" }}>
                    <Breadcrumb.Item><a>Home</a></Breadcrumb.Item>
                    <Breadcrumb.Item>Agent Card Floats</Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
                    <PageHeader className="site-page-header" title="History Agent Card Floats" extra={exportButton()} />
                    <div style={{ padding: 10 }}>
                        <>
                            {tableError && <div style={{ marginBottom: "10px" }}><AlertError title="Error" message={tableError} /></div>}
                            <Collapse accordion style={{ marginBottom: "10px" }}>
                                <Panel header="Filters" key="1">
                                    <form noValidate="novalidate" action="#" onSubmit={formik.handleSubmit}>
                                    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]}>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>Start Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("00:00:00", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("start_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("start_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.start_date && formik.errors.start_date ? (<div className="ant-form-item-explain-error">{formik.errors.start_date}</div>) : null}
                                            </Col>
                                            <Col className="gutter-row" xs={24} md={12} xl={6}>
                                                <label>End Datetime</label>
                                                <DatePicker
                                                    name="start_date"
                                                    showTime defaultValue={moment("23:59:59", "HH:mm:ss")}
                                                    onOk={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                    onChange={(moment) => {
                                                        if (!moment) {
                                                            formik.setFieldValue("end_date", '', false);
                                                        } else {
                                                            formik.setFieldValue("end_date", moment.format("YYYY-MM-DD HH:mm:ss"), false);
                                                        }
                                                    }}
                                                />
                                                {formik.touched.end_date && formik.errors.end_date ? (<div className="ant-form-item-explain-error">{formik.errors.end_date}</div>) : null}
                                            </Col>
                                        </Row>
                                        {error && <div style={{ marginTop: "10px" }}><AlertDismissError title="Error" message={error} /></div>}
                                        <Button style={{ marginTop: "10px" }} type="primary" htmlType="submit" size="large" block loading={loading}>Submit</Button>
                                    </form>
                                </Panel>
                            </Collapse>
                            <Table
                                rowKey={tableColumns[0]}
                                columns={tableColumnsHead}
                                dataSource={tableData || []}
                                loading={loading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                onChange={tableHandleChange}
                                pagination={{
                                    size: 'default',
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    total: tableFilterCount,
                                    showTotal: (total, range) => {
                                        if (total == tableTotalCount) {
                                            return `${range[0]}-${range[1]} of ${total} items`;
                                        } else {
                                            return `${range[0]}-${range[1]} of ${total} items (filtered from ${tableTotalCount} total items)`;
                                        }
                                    },
                                }}
                            />
                        </>
                    </div>
                </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
                Copyright © 2022 AC GROUP | Tap&Go Ticketing v7.0.0
            </Footer>
        </Layout>
    )
}

export default withRouter(AgentCardFloats);